module.exports = __webpack_public_path__ + "static/media/lohgad.b9793ce3.jpg";